import React, { Fragment, useState, useEffect, useRef } from 'react';
import Draggable from 'react-draggable';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import Maximize from '@material-ui/icons/ExpandMore';
import Minimize from '@material-ui/icons/ExpandLess';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import Loader from './Loader';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'fixed',
    bottom: theme.spacing(4),
    left: theme.spacing(4),
    zIndex: 999999999,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    boxShadow: theme.shadows[10],
    opacity: 1,
    minWidth: '300px',
    cursor: 'move',
  },
  hidden: {
    display: 'none',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
    flex: 1,
  },
  progressBar: {
    width: '100%',
    borderRadius: theme.spacing(1),
    marginTop:'0px',
    marginBottom:'20px'
  },
  button: {
    marginTop: theme.spacing(1),
  },
}));

const PendingJobIndicator = (props) => {
  const classes = useStyles();
  const [minimized, setMinimized] = useState(false);
  const [jobs, setJobs]=useState([]);

  const toggleMinimized = () => {setMinimized(!minimized);};

  const [shouldRun, setShouldRun] = useState(true); // State to control whether to continue running the interval
  const job_refresh_interval=10000;
  const ui_refresh_interval=100;

  let last_job_loading=useRef({});

  function refreshJobs(){//Key to undersand is loading is displaying numbers after the fact. This allows proper calculation for number increments in fractions of seconds.
        axios.get('/api/currentJobs/index').then((response)=>{
          if(response.data.length==0){setJobs(undefined);}else{
            let new_jobs=[];
            for(let j of response.data){
              j.historic_loading=j.progress; //Historic loading maintains loading between refreshes
              if(last_job_loading.current[j.id]==undefined){last_job_loading.current[j.id]=0;}
              let complete_loading_interval=j.historic_loading - last_job_loading.current[j.id];
              let total_steps=job_refresh_interval/ui_refresh_interval; //Loading step is how much it should increase every refresh ui to get to the historic loading before next refresh.
              if(j.progress==100){total_steps=total_steps/10;} //THis makes the whole loading speed up x times when reaching 100
              j.loading_step=complete_loading_interval/total_steps;
              j.loading_step=parseFloat(j.loading_step.toFixed(2));
              j.progress=last_job_loading.current[j.id]; //Progress increases every ui refresh and starts from old historic.
              last_job_loading.current[j.id]=j.historic_loading; //Historic loading must be saved in external ref for next job refresh.
              new_jobs.push(j);
            }
            setJobs(new_jobs)
          }
        })
    }
  useEffect(()=>{setTimeout(function(){refreshJobs();},2000);},[]);

  function refreshUI() {
    setJobs(prevJobs => {
        return prevJobs.map(job => {
            let j={ ...job, progress:job.progress + job.loading_step };
            j.progress=parseFloat(j.progress.toFixed(2)); // This is necessary here too for some reason even though both progress and loading_step have 2 decimals. This is due to internal javascript issues in processing floats.
            if(j.progress>100){j.progress=100;}
            return j;
        });
    });
}

  useEffect(() => {
    const interval = setInterval(() => {refreshJobs();}, job_refresh_interval); // 5000 milliseconds = 5 seconds
    const ui_interval = setInterval(()=> {refreshUI();}, ui_refresh_interval);
    return () =>{clearInterval(ui_interval); clearInterval(interval);} // Clean up interval on component unmount
  }, [shouldRun]); // Include shouldRun in the dependency array
  if(jobs!=undefined && window.location.href.includes('/confirmation/required')==false){
    if(jobs.length==0){return null;}
  return (
    <Draggable>
      <Box className={`${classes.root}`} style={{minWidth:(minimized==true)?'100px':'300px'}}>
        <IconButton style={{position:'absolute', top:'0px', right:'5px'}} onClick={()=>{setMinimized(!minimized)}}>{(minimized==true)?<Minimize color='secondary' style={{fontSize:'25px'}}/>:<Maximize color='secondary' style={{fontSize:'25px'}}/>}</IconButton>
        <div className={classes.content}>
          <div style={{ marginLeft: '0px', marginRight: '10px' }}>
            <Loader loading embed small tiny remove_border color='secondary'/>
          </div>
          {(minimized==true)?null:jobs.map(function(j){
            return(
              <Fragment key={j.id}>
                {(j.error==true)?null:<Typography variant='caption' style={{color:'white', marginTop:'10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                  <span style={{textAlign: 'left'}}>{`${j.message}...`}</span>
                  <span style={{textAlign: 'right'}}>{`${j.progress.toFixed(2)}%`}</span>
                </Typography>}
                {(j.error==true)?
                  <div>
                  <div><Typography variant='caption' style={{color:'white'}}>Error: your data may take longer to process</Typography></div>
                  <div><Typography variant='caption' style={{color:'white'}}>You will be notified once it is ready</Typography></div>
                  <div style={{width:'100%', display:'flex', justifyContent:'center', alignItems:'center', marginTop:'20px'}}><Button size='small' variant='contained' color='error' style={{cursor:'pointer'}} onClick={()=>{axios.put('/api/currentJobs/errorReceived/'+j.id)}}>Close</Button></div>
                  </div>:(j.completed==true && j.progress==100)?<Button size='small' variant='contained' color='secondary' style={{cursor:'pointer'}} onClick={()=>{window.location.href='/';}}>Completed</Button>:<LinearProgress variant="determinate" value={j.progress} color='secondary' className={classes.progressBar} />}
              </Fragment>
              )
          })}
        </div>
      </Box>
    </Draggable>
  );
}else{
  props.handleClose();
  return null;
}
};

export default PendingJobIndicator;
